import dynamic from 'next/dynamic';

const GridCellActiveStatus = dynamic(() =>
  import('./GridCellActiveStatus/GridCellActiveStatus')
);
const GridCellDate = dynamic(() => import('./GridCellDate/GridCellDate'));
const GridCellDateNow = dynamic(() =>
  import('./GridCellDateNow/GridCellDateNow')
);
const GridCellFee = dynamic(() => import('./GridCellFee/GridCellFee'));
const GridCellExpand = dynamic(() => import('./GridCellExpand/GridCellExpand'));
const CSVGrid = dynamic(() => import('./CSVGrid/CSVGrid'));
const DataGrid = dynamic(() => import('./DataGrid/DataGrid'));
const GridCellLinkV2 = dynamic(() => import('./GridCellLinkV2/GridCellLinkV2'));
const GridSearch = dynamic(() => import('./GridSearch/GridSearch'));
const GridCalendarFilter = dynamic(() =>
  import('./GridCalendarFilter/GridCalendarFilter')
);
const ManageGridColumns = dynamic(() =>
  import('./ManageGridColumns/ManageGridColumns')
);
const PaginationV2 = dynamic(() => import('./PaginationV2/PaginationV2'));
const KanbanBoardV2 = dynamic(() => import('./KanbanBoardV2/KanbanBoardV2'));
const InstaDataGrid = dynamic(() => import('./InstaDataGrid/InstaDataGrid'));
const GridToolbar = dynamic(() => import('./GridToolbar/GridToolbar'));
const GridFilters = dynamic(() => import('./GridFilters/GridFilters'));
const KanbanWrapper = dynamic(() => import('./KanbanWrapper/KanbanWrapper'));
const GridCellChips = dynamic(() => import('./GridCellChips/GridCellChips'));
const TablePagination = dynamic(() =>
  import('./TablePagination/TablePagination')
);
const KanbanBoard = dynamic(() => import('./KanbanBoard/KanbanBoard'));
const KanbanCardInfoMenu = dynamic(() =>
  import('./KanbanBoard/KanbanCardInfoMenu')
);

export {
  GridCellActiveStatus,
  GridCellDate,
  GridCellDateNow,
  GridCellFee,
  GridCellExpand,
  CSVGrid,
  DataGrid,
  GridCellLinkV2,
  GridSearch,
  ManageGridColumns,
  PaginationV2,
  KanbanBoardV2,
  InstaDataGrid,
  GridToolbar,
  GridCalendarFilter,
  GridFilters,
  KanbanWrapper,
  GridCellChips,
  TablePagination,
  KanbanBoard,
  KanbanCardInfoMenu,
};
